import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'contentGroup',
  'eyebrow',
  'heading',
  'body',
]);

/**
 * Description Block (CF-013 King Difference) – standalone, white background.
 * Figma Desktop 3132-5087: text box 840px, Eyebrow 14px, Feature Heading 46px, Intro 20px; gap 12 (eyebrow–heading), 16 (heading–body).
 * Mobile 3132-6560: width 335px, Eyebrow 12px, Heading 28px, Intro 16px; same gaps.
 */
export const descriptionBlockStyles = helpers.defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      width: '100%',
      maxWidth: '1440px',
      margin: '0 auto',
      padding: {base: '56px 20px', md: '120px 140px'},
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      backgroundColor: '#FFFFFF',
      boxSizing: 'border-box',
    },
    contentGroup: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      maxWidth: {base: '100%', md: '840px'},
    },
    eyebrow: {
      fontFamily: 'aktiv-grotesk, sans-serif',
      fontWeight: 500,
      fontSize: {base: '12px', md: '14px'},
      lineHeight: 1.4,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      textAlign: 'center',
      color: '#282829',
    },
    heading: {
      fontFamily: 'aktiv-grotesk, sans-serif',
      fontWeight: 500,
      fontSize: {base: '28px', md: '46px'},
      lineHeight: 1.2,
      textAlign: 'center',
      color: '#2C2C2C',
    },
    body: {
      fontFamily: 'aktiv-grotesk, sans-serif',
      fontWeight: 400,
      fontSize: {base: '16px', md: '20px'},
      lineHeight: 1.5,
      textAlign: 'center',
      color: '#282829',
      maxWidth: {base: '100%', md: '840px'},
    },
  }),
});
